module.exports = __webpack_public_path__ + "img/aa-desktop-default.476c8dd1.png";